import { TensileRequirementsSpecPage } from "./TensileRequirementsSpecPage";

const LabTensileRequirements = () => {
	return <TensileRequirementsSpecPage />;
};
export default LabTensileRequirements;
